import { useState, useEffect } from "react";
import { Menu, X, ArrowRight } from "lucide-react";
import { NAV } from "@/constants/testIds";

const links = [
  { label: "Home", href: "#home", id: NAV.linkHome },
  { label: "Services", href: "#services", id: NAV.linkServices },
  { label: "Results", href: "#results", id: NAV.linkResults },
  { label: "Process", href: "#process", id: NAV.linkProcess },
  { label: "Packages", href: "#packages", id: NAV.linkPackages },
  { label: "Free Audit", href: "#free-audit-form", id: NAV.linkAudit },
  { label: "Contact", href: "#free-audit-form", id: NAV.linkContact },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-50 transition-all ${
        scrolled ? "bg-white/85 backdrop-blur-xl border-b border-slate-100 shadow-sm" : "bg-white/60 backdrop-blur-md"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center justify-between">
        <a href="#home" data-testid={NAV.logo} className="flex items-center gap-2.5 group">
          <div className="w-10 h-10 rounded-xl bg-slate-900 text-white grid place-items-center font-display font-bold text-sm tracking-tight">AI</div>
          <div className="leading-tight">
            <div className="font-display font-bold text-slate-900 text-[16px]">The AI Growth Pilot</div>
            <div className="text-[10px] uppercase tracking-widest text-blue-600 font-semibold">SEO • Paid Ads • AI Automation</div>
          </div>
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.id}
              data-testid={l.id}
              href={l.href}
              className="text-sm font-medium text-slate-600 hover:text-slate-900 transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="#free-audit-form"
            data-testid={NAV.cta}
            className="hidden sm:inline-flex items-center gap-2 bg-blue-600 text-white hover:bg-blue-700 font-semibold py-2.5 px-5 rounded-full transition-all shadow-lg shadow-blue-600/20 active:scale-95 text-sm"
          >
            Book Free Growth Audit <ArrowRight className="w-4 h-4" />
          </a>
          <button
            aria-label="Toggle menu"
            data-testid={NAV.mobileToggle}
            onClick={() => setOpen((v) => !v)}
            className="lg:hidden p-2 rounded-lg border border-slate-200 text-slate-700"
          >
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-slate-100 bg-white">
          <div className="px-4 py-4 flex flex-col gap-2">
            {links.map((l) => (
              <a
                key={l.id}
                href={l.href}
                onClick={() => setOpen(false)}
                className="py-2 text-slate-700 font-medium"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#free-audit-form"
              onClick={() => setOpen(false)}
              className="mt-2 inline-flex items-center justify-center gap-2 bg-blue-600 text-white font-semibold py-3 px-5 rounded-full"
            >
              Book Free Growth Audit <ArrowRight className="w-4 h-4" />
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
